import { Controller } from "stimulus"

// Impede que um segundo toque em um botão de envio já acionado gere uma
// segunda submissão (FR-026).
//
// Em um totem o toque duplo acidental é comum: a tela é grande, o cidadão está
// em pé e nem sempre percebe que o primeiro toque foi registrado. Duas
// submissões aqui significam dois pré-agendamentos no SOLAR.
//
// Não usamos `data-disable-with` do Rails UJS porque o projeto mistura
// `button_tag` dentro de `form_with local: false` com formulários comuns, e o
// comportamento fica inconsistente entre eles.
//
// Turbolinks está desativado neste projeto (ver packs/application.js), então o
// ciclo de vida é o de páginas comuns: a cada navegação o controller é
// reconstruído e o botão volta habilitado naturalmente.
export default class extends Controller {
  static targets = ["botao"]

  connect() {
    this.enviando = false
    this.element.addEventListener("submit", this.aoEnviar)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.aoEnviar)
  }

  aoEnviar = (event) => {
    if (this.enviando) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }

    // Formulário inválido não é envio: o navegador vai barrar e o cidadão
    // precisa poder corrigir e tentar de novo.
    if (this.element.checkValidity && !this.element.checkValidity()) return

    this.enviando = true
    this.desabilitarBotoes()
  }

  desabilitarBotoes() {
    const botoes = this.hasBotaoTarget
      ? this.botaoTargets
      : Array.from(this.element.querySelectorAll("[type=submit]"))

    botoes.forEach((botao) => {
      botao.disabled = true
      botao.setAttribute("aria-busy", "true")
    })
  }
}
